import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { RemoteTypeLoader, RegexValidator, TypeReader } from "./FTSchemataDef";
import React, { useState, useEffect } from "react";
import { FileProvider } from "./FileContext";

import SSOStandalonePage from "./screens/SSOStandalone/sso_standalone";

function readUserCookie() {
  const rawCookie = document.cookie
    .split('; ')
    .find(row => row.startsWith('ft_user_data='))
    ?.split('=')[1];
  if (!rawCookie) return null;
  try {
    return JSON.parse(atob(decodeURIComponent(rawCookie)));
  } catch {
    return null;
  }
}

function getSavedUser() {
  const cookieUser = readUserCookie();
  if (cookieUser) {
    return {
      isLoggedIn: true,
      name: cookieUser.display_name || "",
      accountType: cookieUser.account_type || null,
    };
  }
  try {
    const stored = localStorage.getItem("ft_user");
    if (stored) return JSON.parse(stored);
  } catch {}
  return { isLoggedIn: false, name: "", accountType: null };
}

function navigateToPage(pageName) {
	const urlObj = new URL(pageName);
	if (urlObj.hostname.endsWith("fishtagged.org") == false || pageName.startsWith("https://") == false) {
		if (window.confirm(`This page wants to take you to ${pageName}. Is that OK?`)) {
			window.location.href = pageName
		}
	}
	else {
		window.location.href = pageName;
	}
}

function closeCurrentPage() {
	window.close()
}

function handleOKLogin() {
	const urlParams = new URLSearchParams(window.location.search);
	const hasCloseAfterOK = urlParams.has("close_after_login")
	const hasNext = urlParams.has("next")
	if (hasCloseAfterOK) {
		closeCurrentPage();
	}
	else if (hasNext) {
		navigateToPage(urlParams.get("next"));
	}
	else {
		window.alert("Login was successful; however, no subsequent action is configured.")
	}

}

function App() {
  const [typesLoaded, setTypesLoaded] = useState(false);
  const [types, setTypes] = useState({});
  const [user, setUser] = useState(() => getSavedUser());

  const setUserAndPersist = (newUser) => {
    setUser(newUser);
    if (newUser.isLoggedIn) {
      localStorage.setItem("ft_user", JSON.stringify(newUser));
    } else {
      localStorage.removeItem("ft_user");
    }
  };

  useEffect(() => {
    RemoteTypeLoader.loadNamespaces(["std", "tagapp"], () => {
      console.log("Standard types loaded globally.");

      const loadedTypes = { ...TypeReader.types };
      const emailType = loadedTypes["std.email"];
      if (emailType) {
        emailType.validator_list = emailType.validator_list.filter(
          v => !(v instanceof RegexValidator && v.regex === "placeholder")
        );
        const emailPattern = "^[a-zA-Z0-9]+(?:\\.[a-zA-Z0-9]+)*@[a-zA-Z0-9]+\\.[a-zA-Z]{2,}$";
        emailType.validator_list.push(new RegexValidator("std.email", emailPattern));
      }

      setTypes(loadedTypes);
      setTypesLoaded(true);
    });
  }, []);

  useEffect(() => {
    if (typesLoaded) {
      console.log("Updated types in state:", types);
      console.log("std.email exists in state:", types["std.email"]);
    }
  }, [typesLoaded, types]);

  if (!typesLoaded) {
    return <div>Pulling data from FishTagged servers...</div>;
  }

  return (
    <FileProvider>
      <Router>
        <Routes>
		  <Route path="/" element={<SSOStandalonePage user={user} onLoginSuccess={handleOKLogin} />} />
        </Routes>
      </Router>
    </FileProvider>
  );
}

export default App;